module.exports = __webpack_public_path__ + "static/media/CX.7ce715e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/CX.svg
// module id = 2136
// module chunks = 7